import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { AppService } from "src/app/services/services";
import { ValidationService } from '../../../validators/validation.service';

@Component({
    selector: 'nri-app-address-info',
    templateUrl: './address-info.component.html',
    styleUrls: ['./address-info.component.scss']
})


export class AddressInfoComponent implements OnInit{
    @Input() data: any;
    @Input() type: any
    @Input() addressGetData: any;
    @Output() addressFormValid = new EventEmitter();
    addressValue: any = {};
    addressForm = this.formBuilder.group({
        'Address1': ['', [Validators.required, Validators.minLength(3), this.noWhitespaceValidator]],
        'Address2': ['', [Validators.required, Validators.minLength(3), this.noWhitespaceValidator]],
        'Address3': ['', [Validators.required, Validators.minLength(3), this.noWhitespaceValidator]],
        'City': ['',Validators.required],
        'Country': ['',Validators.required],
        'Pincode': ['',Validators.required],
        'State': ['',Validators.required]
    });
    countryList: any;
    countryName: any;

    constructor(public formBuilder: FormBuilder, public _http: AppService){
        this.countryList = this._http.countryList;
    }

    ngOnInit() {
      this.onAddressFormValueChange();
      if(this.addressGetData && this.addressGetData.Address1){
        this.addressForm.patchValue({
            'Address1': this.addressGetData.Address1,
            'Address2': this.addressGetData.Address2,
            'Address3': this.addressGetData.Address3,
            'City': this.addressGetData.City,
            'State': this.addressGetData.State,
            'Pincode': this.addressGetData.Pincode,
            'Country': this.addressGetData.Country
        });
      }
    }

    onAddressFormValueChange(){
      this.addressForm.valueChanges.subscribe( (value:any) => {
        if(this.addressForm.valid){
            let param = {
                status: true,
                data: this.addressForm.value
            }
            this.addressFormValid.emit(param)
        }else{
            let param = {
                status: false,
                data: ''
            }
            this.addressFormValid.emit(param)
        }
    });
    }

    public noWhitespaceValidator(control: FormControl) {
        return (control.value || '').trim().length? null : { 'whitespace': true };       
    }

    // onInputChange(event:any){
    //     const pattern = new RegExp('^[a-zA-Z0-9., \b]+$');
    //     const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    //     if (!pattern.test(key) && event.charCode !== 0) {
    //         event.preventDefault();
    //         return;
    //     }
    //   }

      onInputChanged(event: Event) {
        const inputElement = event.target as HTMLInputElement;
        const currentValue = inputElement.value;
        const allowedCharacters = /^[a-zA-Z0-9.,/\s]+$/;
      
        // Remove disallowed characters from the input value
        const sanitizedValue = currentValue.split('').filter(char => allowedCharacters.test(char)).join('');
      
        // Set the sanitized value back to the input field
        inputElement.value = sanitizedValue;
      }

      onInputChange(event: any) {
        const pattern = /^[a-zA-Z \b]+$/;
        const inputText = event.target.value;
      
        if (!pattern.test(inputText)) {
          // Remove invalid characters from the input value
          event.target.value = inputText.replace(new RegExp(`[^a-zA-Z \b]+`, 'g'), '');
        }
      }
    
    // alphabetOnly(event:any){
    //     const pattern = new RegExp('^[a-zA-Z \b]+$');
    //     const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    //     if (!pattern.test(key) && event.charCode !== 0) {
    //         event.preventDefault();
    //         return;
    //     }
    // }
    
    // alphabetNumericOnly(event:any){
    //     const pattern = new RegExp('^[a-zA-Z0-9 \b]+$');
    //     const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    //     if (!pattern.test(key) && event.charCode !== 0) {
    //         event.preventDefault();
    //         return;
    //     }
    // }
    alphaNumeric(event: any) {
        const pattern = /^[a-zA-Z0-9\b]+/;
        const inputText = event.target.value;
      
        if (!pattern.test(inputText)) {
          // Remove non-alphanumeric characters from the input value
          event.target.value = inputText.replace(new RegExp(`[^a-zA-Z0-9]+`, 'g'), '');
        }
      }
      
    spaceValidation(event:any, name: string){
        const input = event.target.value;
        event.target.value = input.replace(/^\s+|\s+$|\s+(?=\s)/g, "");
        if(name === 'Address1' || name === 'Address2' || name === 'Address3' || name === 'City' || name === 'State' || name === 'Pincode'){
            this.addressForm.controls[name].setValue(event.target.value);
        }
    }
    
    getCountryName(){
        let a:any = this.addressForm.controls.Country.value;
        let c = parseInt(a);
        let name = this.countryList.filter((e:any)=>{
          return e.Id === c;
        })
        this.countryName = name[0].Name;
      }
       alphaNumerics(event: any) {
      const inputText = event.target.value;
      const sanitizedText = inputText.replace(/[^a-zA-Z0-9.,]/g, ''); 

      if (inputText !== sanitizedText) {
        event.target.value = sanitizedText;
      }
    }

}